const jsonOrStr = (o) => {
    return typeof o === "object" ? JSON.stringify(o, null, 2) : String(o);
};
export const axiosResponseToHTTPTran = (r) => {
    const { data: payload, headers, status, statusText } = r;
    return {
        methodOrStatus: status,
        urlOrStatusText: statusText,
        headers,
        payload,
    };
};
export const axiosConfigToHTTPTran = (c) => {
    const { method, url, baseURL, headers, data: payload } = c;
    return { methodOrStatus: method, urlOrStatusText: baseURL ?? "" + url ?? "", headers, payload };
};
export const stringifyHTTPTransaction = ({ methodOrStatus, urlOrStatusText, headers, payload, }) => {
    return [
        `${String(methodOrStatus || "UNKNOWN").toUpperCase()} ${String(urlOrStatusText)}`,
        ...headersLines(headers),
        "",
        jsonOrStr(payload),
    ]
        .map(s => `  ${s}`)
        .join("\n");
};
const headersLines = (headers) => {
    if (typeof headers === "object") {
        return Object.keys(headers).map(k => `${k}: ${headers[k]}`);
    }
    return [String(headers)];
};
// export const isAxiosResponse = (resp: any): resp is AxiosResponse => {
//     return !!resp["data"]
//     data
//     status
//     statusText
//     headers
//     config
// }
export const isAxiosError = (err) => {
    return !!err["isAxiosError"];
};
export class ErrorBase extends Error {
    constructor(message) {
        super(message); // 'Error' breaks prototype chain here
        Object.setPrototypeOf(this, new.target.prototype); // restore prototype chain
    }
    toJSON() {
        return { name: this.name, stack: this.stack };
    }
    toString() {
        return `${this.name}: ${this.message}`;
    }
}
export class HTTPError extends ErrorBase {
    constructor(message, response) {
        super(message);
        this.message = message;
        this.response = response;
        this.name = "HTTP Error";
        if (Error.captureStackTrace) {
            Error.captureStackTrace(this, HTTPError);
        }
    }
    static fromAxiosResponse(response) {
        const message = isAxiosError(response) ? response.message : "HTTP Request Failed";
        return new HTTPError(message, response);
    }
    toString() {
        const { name, request, response } = this.toJSON();
        return [
            `${name}: ${this.message}\n`,
            `=== HTTP TRANSACTION ===`,
            stringifyHTTPTransaction(request),
            `---`,
            response ? stringifyHTTPTransaction(response) : "HTTP request failed to send",
        ].join("\n");
    }
    toJSON() {
        let response = undefined;
        if (isAxiosError(this.response)) {
            if (this.response.response) {
                response = axiosResponseToHTTPTran(this.response.response);
            }
            // NOTE: Hole here, not what sure what to do in this case.
        }
        else {
            response = axiosResponseToHTTPTran(this.response);
        }
        return {
            ...super.toJSON(),
            request: axiosConfigToHTTPTran(this.response.config),
            response,
        };
    }
}
//# sourceMappingURL=errors.js.map